import React from 'react'
import styled from '@emotion/styled'
import { string, object } from 'prop-types'

// Import Components (SVGS)
import { Facebook } from '../svgs/Facebook'
import { LinkedIn } from '../svgs/LinkedIn'
import { Twitter } from '../svgs/Twitter'
import { Instagram } from '../svgs/Instagram'
import { Pinterest } from '../svgs/Pinterest'
import { Link } from '@jelly/ui'

const SocialMediaIconLink = styled(Link)`
	margin-right: 10px;
	height: 30px;

	svg {
		width: 30px;
		height: 30px;
	}
`
const SOCIAL_BUTTONS = {
	facebook: Facebook,
	twitter: Twitter,
	linkedin: LinkedIn,
	instagram: Instagram,
	pinterest: Pinterest,
}
/**
 * This is the Social Media Component for non-bdc related social media groups
 */

export const SocialProfileButtons = ({ buttons = {}, color, name, backgroundColor, rel = '', variant = 'neutral' }) =>
	Object.keys(buttons).reduce((withLinksList, social) => {
		const SocialIcon = SOCIAL_BUTTONS[social]
		if (buttons[social] && SOCIAL_BUTTONS[social]) {
			const altText = `${name} ${social}`
			const relAttribute = `noopener noreferrer ${rel}`
			return [
				...withLinksList,
				<SocialMediaIconLink
					key={altText}
					alt={altText}
					href={buttons[social]}
					rel={relAttribute}
					target="_blank"
					backgroundColor={backgroundColor}
				>
					<SocialIcon color={color} backgroundColor={backgroundColor} variant={variant} />
				</SocialMediaIconLink>,
			]
		}
		return [...withLinksList]
	}, [])

SocialProfileButtons.propTypes = {
	buttons: object,
	color: string,
	name: string,
	backgroundColor: string,
	rel: string,
	variant: string,
}
